/**
 * Куда вернуть пользователя после входа: адрес страницы, с которой его увели на /login
 * (прямая ссылка, обновление страницы, протухшая сессия).
 */
const KEY = 'richat.returnTo';

export function rememberReturnTo(path: string) {
  if (!path || path.startsWith('/login')) return;
  try {
    window.sessionStorage.setItem(KEY, path);
  } catch {
    /* недоступно — вернём на главную */
  }
}

/** Забрать адрес возврата (один раз). По умолчанию — Главная. */
export function takeReturnTo(): string {
  try {
    const v = window.sessionStorage.getItem(KEY);
    window.sessionStorage.removeItem(KEY);
    if (v && v.startsWith('/') && !v.startsWith('//')) return v;
  } catch {
    /* ignore */
  }
  return '/';
}
